import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DiscountListContainer } from "@/components/features/items/discount/list";

import { useConfirmParams } from "./hooks";

export const DiscountListPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="ディスカウントの一覧" url={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.TOP, { hotelID })}>
			<DiscountListContainer hotelID={hotelID} />
		</PageMeta>
	);
};
